import { render, staticRenderFns } from "./AnalyteLabResultUnitMismatchRecordItem.vue?vue&type=template&id=0da3e7ac&scoped=true"
import script from "./AnalyteLabResultUnitMismatchRecordItem.vue?vue&type=script&lang=js"
export * from "./AnalyteLabResultUnitMismatchRecordItem.vue?vue&type=script&lang=js"
import style0 from "./AnalyteLabResultUnitMismatchRecordItem.vue?vue&type=style&index=0&id=0da3e7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da3e7ac",
  null
  
)

export default component.exports